<!--
  @description Renders icon links to the Allez! Allez! social media accounts: Facebook, Instagram,
  and YouTube. All links open in a new tab. No props — the URLs and icons are hardcoded. Intended
  for use in Footer and any marketing section that needs social links.

  @example
  <Socials />

  @accessibility Each anchor carries an explicit `aria-label` (e.g. "Facebook") so screen readers
  announce the destination rather than the icon glyph.
-->
<template>
  <div class="socials">
    <a
      class="no-active"
      aria-label="Facebook"
      href="https://www.facebook.com/profile.php?id=100095260045646"
      target="_blank"
    >
      <i class="socials__icon fi fi-brands-facebook"></i>
    </a>
    <a
      class="no-active logo"
      aria-label="Instagram"
      href="https://www.instagram.com/allez.allez.app/"
      target="_blank"
    >
      <i class="socials__icon fi fi-brands-instagram"></i>
    </a>
    <a
      class="no-active logo"
      aria-label="Youtube"
      href="https://www.youtube.com/@AllezAllezApp"
      target="_blank"
    >
      <i class="socials__icon fi fi-brands-youtube"></i>
    </a>
  </div>
</template>

<style scoped lang="scss">
.socials {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  width: fit-content;

  &__icon {
    color: var(--text);
    font-size: 1.4rem;
    transform: translateY(3px);
    transition: all 0.2s ease-in-out;
    cursor: pointer;

    &.fi-brands-youtube:hover {
      color: #ff0000;
    }

    &.fi-brands-facebook:hover {
      color: #4267b2;
    }

    &.fi-brands-instagram:hover {
      background: linear-gradient(
        135deg,
        #405de6 0%,
        #5b51d8 10%,
        #833ab4 20%,
        #c13584 30%,
        #e1306c 40%,
        #fd1d1d 50%,
        #f56040 60%,
        #f77737 70%,
        #fcaf45 80%,
        #ffdc80 90%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  @include breakpoint-md {
    transform: scale(0.8);
  }
}
</style>
